import { SharePointFolderStatus } from "projects/models";

export type SharePointFolderStatusMeta = {
  label: string;
  color: string;
  /** True when the folder is expected but not present (needs recreating). */
  isMissing: boolean;
};

const META: Record<SharePointFolderStatus, SharePointFolderStatusMeta> = {
  created: { label: "Folder created", color: "green", isMissing: false },
  failed: { label: "No folder", color: "red", isMissing: true },
  pending: { label: "No folder", color: "orange", isMissing: true },
  skipped: { label: "Not applicable", color: "default", isMissing: false },
};

/**
 * Map a project's SharePoint folder status to display metadata. Unknown/undefined
 * status is treated as `pending` (a folder is expected but not confirmed).
 */
export const getSharePointFolderStatusMeta = (
  status?: SharePointFolderStatus | null
): SharePointFolderStatusMeta => META[status ?? "pending"] ?? META.pending;
